export const NAV = [
  { key: "entdecken", label: "Entdecken", items: [
    { to: "/entdecken", label: "Orte & Aktivitäten", id: "discover", desc: "Strände, Museen, Natur, Gastronomie" },
    { to: "/entdecken/themen", label: "Themenwelten", id: "themes", desc: "E-Bike, Kanu, Camping, Hund, barrierefrei" },
    { to: "/karte", label: "Karte", id: "map", desc: "Alles auf einen Blick" },
    { to: "/merkliste", label: "Merkliste", id: "favorites-menu", desc: "Deine gemerkten Veranstaltungen" },
  ] },
  { key: "erleben", label: "Erleben", items: [
    { to: "/veranstaltungen", label: "Veranstaltungen", id: "events", desc: "Kalender für ganz Ostfriesland" },
    { to: "/wochenende", label: "Dieses Wochenende", id: "weekend", desc: "Fr–So: Events, Märkte, Wetter, Gezeiten" },
    { to: "/einreichen", label: "Veranstaltung einreichen", id: "submit-menu", desc: "Teile, was bei dir los ist" },
  ] },
  { key: "orte", label: "Orte", items: [
    { to: "/orte", label: "Alle Orte", id: "towns", desc: "20 Städte, Sielorte und Dörfer" },
    ...[["emden", "Emden"], ["aurich", "Aurich"], ["leer", "Leer"], ["norden", "Norden"], ["norddeich", "Norddeich"], ["greetsiel", "Greetsiel"], ["neuharlingersiel", "Neuharlingersiel"], ["wittmund", "Wittmund"]]
      .map(([s, n]) => ({ to: `/orte/${s}`, label: n, id: `town-${s}` })),
  ] },
  { key: "inseln", label: "Inseln", items: [
    { to: "/inseln", label: "Alle Inseln", id: "islands", desc: "Sieben Inseln im Überblick" },
    ...["Borkum", "Juist", "Norderney", "Baltrum", "Langeoog", "Spiekeroog", "Wangerooge"].map((n) => ({ to: `/inseln/${n.toLowerCase()}`, label: n, id: `island-${n.toLowerCase()}` })),
  ] },
  { key: "kueste", label: "Küste live", items: [
    { to: "/wetter", label: "Wetter & Warnungen", id: "weather", desc: "Vorhersage, Radar, bester Tag" },
    { to: "/gezeiten", label: "Gezeiten & Pegel", id: "tides", desc: "Tidenkalender und Live-Wasserstände" },
    { to: "/wetter?tab=kueste", label: "Watt & Mond", id: "watt", desc: "Wattwanderungs-Fenster, Springtide" },
    { to: "/wattfuehrer", label: "Wattführer", id: "watt-guides", desc: "Geführte Wattwanderungen buchen" },
    { to: "/wetter?tab=strand", label: "Strand & Wind", id: "beach", desc: "Wasser, Wellen, Beaufort-Ampel" },
    { to: "/badestellen", label: "Badestellen", id: "bathing", desc: "EU-Wasserqualität und Wassertemperatur" },
    { to: "/deich-rad", label: "Deich & Rad", id: "deich-rad", desc: "Gegenwind und bestes Zeitfenster" },
    { to: "/wetter?tab=gesundheit", label: "Pollen & UV", id: "health", desc: "Pollenflug, Luft, Sonne" },
  ] },
  { key: "anreise", label: "Anreise", items: [
    { to: "/anreise", label: "Fähren & Inselflüge", id: "arrival", desc: "Häfen, Fahrzeiten, Tipps" },
  ] },
];
